<template>
  <v-container>
    <!-- List information -->
    <v-card class="pa-2" elevation="6">
      <v-list>
        <v-list-item-group>
          <v-list-item
            v-for="(item, index) in listSelectDiv"
            :key="'h-' + index"
            @click="btnShow(item)"
            class="custom-list-item"
          >
            <v-list-item-icon>
              <v-icon color="primary">mdi-account-edit</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                {{ item.name }}
              </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-icon color="grey">mdi-chevron-right</v-icon>
            </v-list-item-action>
          </v-list-item>
          <!-- Chỉ hiển thị divider nếu không phải là phần tử cuối cùng -->
          <!-- <v-divider v-if="index !== listSelectDiv.length - 1"></v-divider> -->
        </v-list-item-group>
      </v-list>
    </v-card>
    <!-- Dialog Fullscreen -->
    <v-dialog v-model="showFullScreen" fullscreen persistent >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="showFullScreen = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ selectDivision }}</v-toolbar-title>
        </v-toolbar>
        <v-sheet style="overflow-x: auto; overflow-y: auto" max-height="calc(100vh - 55px)">  
          <template>
            <div class="w-container" v-if="selectDiv != '0'">
                <v-row class="pa-0 ma-0"  v-if="selectDiv === '1'">
                  <v-col cols="12" class="w-content pa-0">
                    <dockBatch :value="1"></dockBatch>
                  </v-col>                
                </v-row>
                <v-divider class="custom-divider"></v-divider>
                <v-row class="pa-0 ma-0" v-if="selectDiv === '1'">
                  <v-col cols="12" class="w-content pa-0">
                    <dockBatch :value="2"></dockBatch>
                  </v-col>                 
                </v-row>
                <v-divider class="custom-divider"></v-divider>
                <v-row class="pa-0 ma-0" v-if="selectDiv === '1'">
                  <v-col cols="12" class="main-plan w-content pa-0">
                    <dockBatch :value="3"></dockBatch>
                  </v-col>
                
                </v-row>

                <v-row class="pa-0 ma-0" v-if="selectDiv === '2'">
                  <v-col cols="12" class="pa-1 w-content">
                    <statusManPower />
                  </v-col>
                </v-row>
                <v-row class="pa-0 ma-0" v-if="selectDiv === '3'">
                  <v-col cols="12" class="pa-1 w-content">
                    <statusBlasting />
                  </v-col>
                </v-row>
                <v-row class="pa-0 ma-0" v-if="selectDiv === '4'">
                  <v-col cols="12" class="pa-1 w-content">
                    <statusInspection />
                  </v-col>
                </v-row>
            </div>

            <div class="w-container" v-if="selectDiv === '0'">
                <v-row class="pa-0 ma-0"  >
                  <v-col cols="12" class="w-content pa-0">
                    <dockBatch :value="1"></dockBatch>
                  </v-col>                
                </v-row>
                <v-divider class="custom-divider"></v-divider>
                <v-row class="pa-0 ma-0" >
                  <v-col cols="12" class="w-content pa-0">
                    <dockBatch :value="2"></dockBatch>
                  </v-col>                 
                </v-row>
                <v-divider class="custom-divider"></v-divider>
                <v-row class="pa-0 ma-0" >
                  <v-col cols="12" class="main-plan w-content pa-0">
                    <dockBatch :value="3"></dockBatch>
                  </v-col>                
                </v-row>
                <v-divider class="custom-divider"></v-divider>
                <v-row class="pa-0 ma-0" >
                  <v-col cols="12" class="pa-1 w-content">
                    <statusManPower />
                  </v-col>
                </v-row>
                <v-divider class="custom-divider"></v-divider>
                <v-row class="pa-0 ma-0" >
                  <v-col cols="12" class="pa-1 w-content">
                    <statusBlasting />
                  </v-col>
                </v-row>
                <v-divider class="custom-divider"></v-divider>
                <v-row class="pa-0 ma-0" >
                  <v-col cols="12" class="pa-1 w-content">
                    <statusInspection />
                  </v-col>
                </v-row>
            </div>
          </template>
        </v-sheet>  
      </v-card>
    </v-dialog>  
  </v-container>
</template>


<script>
import dockBatch from './v20a6000mDockBatch'
import dockBatchPC from './v20a6000pcDockBatch'
import statusManPower from './v20a6000mStatusMP'
import statusBlasting from './v20a6000mBlastingBlock'
import statusInspection from './v20a6000pcStatusInspection'


import { DxScrollView } from 'devextreme-vue/scroll-view'
import { DxPopup } from 'devextreme-vue/popup'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page addition
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // Add base when using data grid
import notify from 'devextreme/ui/notify' // message
import { getDateFormat, getCurrentDate } from '@/utils/common.js'
import dayjs from 'dayjs'
import moment from 'moment'
import { fn_uni2vni, fn_vni2uni } from '@/api/view/pp/common/common.js'
import EventBus from '@/components/event-bus'

export default {
  name: 'v20a6000m',
  mixins: [baseview, BaseDataGrid],

   components: {
    dockBatch,
    dockBatchPC,
    statusManPower,
    statusBlasting,
    statusInspection
  },

  props: {
    isHidden: Boolean,
    routeName: String,
  },

  data: () => ({
    openedPanel: 1,
    cOpenedPanel: -1,
    txtFilter: '',
    showFullScreen: false,

    selected: [0],
    fab: false,
    dark: false,
    cboSelectDiv:'0',
    selectDiv: '0',
    selectedItem: {}, // Lưu item được chọn
    headers: [
      { text: 'Code', value: 'code' },
      { text: 'Name', value: 'name' }
    ],
    listSelectDiv: [
      {code: '0', name: 'Status of the Pre Painting'},
      {code: '1', name: 'Dock Status'},
      {code: '2', name: 'Status of Manpower on Today'},
      {code: '3', name: 'Blasting Working Blocks'},
      {code: '4', name: 'Status of Inspection on Today'},
    ],
    listSize: 0,
  }),

  created() {
    // Nếu danh sách không rỗng, lấy phần tử đầu tiên
    if (this.listSelectDiv.length > 0) {
      this.selectedItem = this.listSelectDiv[0];
    }
    // console.log("created_search: ", this.$options.name + "_search");
    // console.log("created_selectedItem: ", this.selectedItem);
    EventBus.$on(this.$options.name + '_search', () => {
      // console.log("EventBus: ", this.selectedItem);
      this.btnShow(this.selectedItem)
    })
  },

  mounted() { 
      // console.log("show_routeName: ", this.routeName);
      // console.log("show_Dialog: ", this.screenSize);
      // Nếu danh sách không rỗng, lấy phần tử đầu tiên
      if (this.listSelectDiv.length > 0) {
        this.selectedItem = this.listSelectDiv[0];
      }

      if(this.screenSize==='md'||this.screenSize==='lg'||this.screenSize==='xl'){
        this.showFullScreen = false
      }else{
        this.btnShow(this.selectedItem)
      }    
  },

  beforeDestroy() {
    // console.log("beforeDestroy: "+this.$options.name + "_search");
    EventBus.$off(this.$options.name + '_search')
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown; // Trả về true nếu màn hình nhỏ hơn mobileBreakpoint (mặc định 1264px)
    },
    screenSize() {
      return this.$vuetify.breakpoint.name; // Trả về tên breakpoint: 'xs', 'sm', 'md', 'lg', 'xl'
    },

    selectDivision: function() {
      const items = this.listSelectDiv.filter(item => item.code && item.code === this.selectedItem.code)
      return items.length > 0 ? items[0].name : 'Status of the Pre Painting'
    },
  },

  watch: {
    isMobile(newValue) {
      // console.log("isMobile_m: ", newValue);
    },

    screenSize(newValue){
      // console.log("showDialog: ", newValue);
      if(newValue==='md'||newValue==='lg'||newValue==='xl'){
        this.showFullScreen = false
      }else{
        this.btnShow(this.selectedItem)
      }
      
    }
     
  },

  methods: {

    btnShow(item) {
      // console.log(item.code);
      this.selectedItem = item;
      this.showFullScreen = true
      this.openedPanel = 1
      this.selectDiv = item.code
      
    },

  }
}
</script>
<style >
  .custom-divider {
    border-color: red; /* Đổi màu */
    border-width: 2px; /* Tăng độ dày */
  }

  /* Tạo hiệu ứng hover đẹp hơn */
  .custom-list-item {
    transition: background-color 0.3s;
  }
  .custom-list-item:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
</style>
